<template>
    <velt-wireframe style="display:none;">
        <velt-comment-composer-wireframe variant="listen">
            <velt-comment-dialog-composer-wireframe>
                <velt-comment-dialog-composer-input-wireframe placeholder="Add comment..." />
                <velt-comment-dialog-composer-action-button-wireframe type="submit" />
            </velt-comment-dialog-composer-wireframe>
        </velt-comment-composer-wireframe>
    </velt-wireframe>
</template>

<script>
export default {
    name: 'CommentComposer',
};
</script>
